import { MaskedLines, Reveal } from "@/components/Reveal";

const SectionHeading = ({ overline, lines, texto, className = "", large = false, inView = true, testid }) => (
  <div className={className} data-testid={testid}>
    <Reveal>
      <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-brand">{overline}</p>
    </Reveal>
    <MaskedLines
      inView={inView}
      className={`mt-4 font-serif leading-snug tracking-tight text-[#F4F4F6] ${
        large ? "text-3xl leading-tight sm:text-4xl lg:text-5xl" : "text-2xl sm:text-3xl lg:text-4xl"
      }`}
      lines={lines}
    />
    {texto && (
      <Reveal delay={0.15}>
        <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-stone-400">{texto}</p>
      </Reveal>
    )}
  </div>
);

export default SectionHeading;
